import {SearchList} from '../../models/search-list.model';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {FormState} from '../../models/form-state.model';
import {Injectable} from '@angular/core';
import {CoAcquisitionService} from '../../services/co-acquisition.service';
import {handleFetchListPage} from '../../helpers/search.helper';
import {CoAcquisitionActions} from './co-acquisition.actions';
import {Product} from '../../models/product.model';
import {Partner} from '../../models/partner.model';
import {CoAcquisition} from '../../models/co-acquisition.model';
import {setFormStatus, setFormValidationErrors} from '../../helpers/form.helper';
import {FormStatus} from '../../enums/file-status.enum';
import {NavService} from '../../services/nav.service';
import {NavItemCodes} from '../../enums/nav-item-codes.enum';
import {map} from 'rxjs/operators';

interface CoAcquisitionStateModel {
    form: FormState;
    list: SearchList<{}>;
    activeCoAcquisition: {};
    productFieldList: Product[];
    partnerFieldList: Partner[];
}

const STATE_NAME = 'coAcquisition';

@State<CoAcquisitionStateModel>({
    name: STATE_NAME,
    defaults: {
        form: new FormState(),
        list: new SearchList<CoAcquisition>({
            filters: new FormState()
        }),
        productFieldList: [],
        partnerFieldList: [],
        activeCoAcquisition: {},
    }
})

@Injectable()
export class CoAcquisitionState {

    constructor(private coAcquisitionService: CoAcquisitionService, private navService: NavService) {
    }

    @Selector()
    static coAcquisitionList(state) {
        return state.list;
    }

    @Selector()
    static activeCoAcquisition(state) {
        return state.activeCoAcquisition;
    }

    @Selector()
    static coacquisitionFormErrors(state) {
        return state.form.validationErrors;
    }

    @Action(CoAcquisitionActions.GetListPage)
    getListPage(ctx: StateContext<CoAcquisitionStateModel>, action: CoAcquisitionActions.GetListPage) {
        return handleFetchListPage(ctx, action.params, (props) => this.coAcquisitionService.fetchList(props));
    }

    @Action(CoAcquisitionActions.Add)
    add(ctx: StateContext<CoAcquisitionStateModel>, {coAcquisition}: CoAcquisitionActions.Add) {
        setFormStatus(ctx, FormStatus.PENDING, STATE_NAME);
        return this.coAcquisitionService.add(coAcquisition).subscribe(
            () => this.navService.navigateByCode(NavItemCodes.CO_ACQUISITION_CONFIGURATION),
            ({error}) => ctx.dispatch(new CoAcquisitionActions.FormFailure(error))
        );
    }

    @Action(CoAcquisitionActions.Update)
    updateCoAcquisition(ctx: StateContext<CoAcquisitionStateModel>, {coAcquisition}: CoAcquisitionActions.Update) {
        setFormStatus(ctx, FormStatus.PENDING, STATE_NAME);
        return this.coAcquisitionService.update(coAcquisition).subscribe(
            () => this.navService.navigateByCode(NavItemCodes.CO_ACQUISITION_CONFIGURATION),
            ({error}) => ctx.dispatch(new CoAcquisitionActions.FormFailure(error))
        );
    }

    @Action(CoAcquisitionActions.GetById)
    getCoAcquisition(ctx: StateContext<CoAcquisitionStateModel>, {id}: CoAcquisitionActions.GetById) {
        return this.coAcquisitionService.fetchById(id)
            .pipe(map(coAcquisition => ctx.patchState({activeCoAcquisition: coAcquisition})));
    }

    @Action(CoAcquisitionActions.Delete)
    deleteCoAcquisition(ctx: StateContext<CoAcquisitionStateModel>, {id}: CoAcquisitionActions.Delete) {
        return this.coAcquisitionService.delete(id).subscribe(
            () => ctx.dispatch(new CoAcquisitionActions.GetListPage())
        );
    }

    @Action(CoAcquisitionActions.FormFailure)
    addCoacquisitionFormFailure(ctx: StateContext<CoAcquisitionStateModel>, {validationErrors = []}: CoAcquisitionActions.FormFailure) {
        setFormValidationErrors(ctx, validationErrors, STATE_NAME);
    }
}

